import enLocale from './en'

export default {
  Growth: {
    rentalTitle: "レンタル市場",
    rentalDesc: "他の保有者からライセンスを借りる。出品すれば賃料を得られます",
    listingCount: "出品中",
    avgDailyRent: "平均日額",
    deals7d: "成約 (7日)",
    totalRent: "総賃料",
    termLabel: "期間",
    dailyRent: "1日あたり",
    annualized: "年利換算",
    rentNow: "借りる",
    sortDaily: "日額順",
    sortTerm: "期間順",
    sortPrice: "賃料順",
    sortNewest: "新着順",

    leaderboard: "成績ランキング",
    leaderboardDesc: "オンチェーンで確定した実績に基づくトレーダー排行",
    winRate: "的中率",
    bets: "回数",
    volume: "取引量",
    record: "{w}勝 · {l}敗",
    winLose: "勝 / 敗",
    loadMore: "もっと見る",
    empty: "データがありません",
    trader: "トレーダー",
    rankLabel: "順位",
    selling: "出品中",
    recent: "最近の結果",
    none: "なし",
    follow: "コピー",
    modeSale: "売却",
    modeRental: "レンタル",
    day: "日",
    periodAll: "全期間",
    period90: "90日",
    period30: "30日",
    period7: "7日",
    sortRoi: "ROI順",
    sortProfit: "損益順",
    sortWinRate: "的中率順",
    sortVolume: "出来高順",
    sortBets: "回数順",
    referralCenter: "紹介センター",
    referralRewards: "紹介報酬",
    referralRewardsDesc: "友だちを招待して報酬をシェア、VIPプールも確認できます",
    myMode: "マイモード",
    modeTeam: "チーム",
    modeAgent: "エージェント",
    l1Rate: "L1率",
    l2Rate: "L2率",
    myUpline: "上位者",
    uplineNone: "なし",
    myVip: "VIPレベル",
    vipNotEnabled: "VIPプールは無効です",
    vipNext: "次のレベル",
    vipDirect: "直接紹介",
    vipAsset: "個人資産",
    vipTeamQualified: "達成チーム",
    vipPools: "受取可能プール",
    tabTeam: "チーム",
    teamLevel: "レベル",
    teamMembers: "メンバー",
    tabCommission: "コミッション",
    commLevel: "レベル",
    commRate: "率",
    commAmount: "金額",
    statusPending: "未決済",
    statusSettled: "決済済み",
    channelOnChain: "オンチェーン",
    channelPlatform: "プラットフォーム",
    communityGroup: "コミュニティ",
    referralDesc: "友人を招待してコミュニティを広げ、活動から報奨を獲得しましょう。",
    connectFirst: "ウォレットを接続して紹介センターを表示",
    directInvites: "直接招待",
    totalDownline: "チーム総数",
    earned: "累計報奨",
    pendingClaim: "受取待ち",
    myReferrer: "紹介者",
    inviteLink: "招待リンク",
    copy: "コピー",
    copied: "コピーしました！",
    linkHint: "このリンクから参加しオンチェーンで紐付けられたユーザーはあなたの招待として計上されます。",
    tabInvitees: "招待一覧",
    tabRewards: "報奨履歴",
    tabTop: "紹介ランキング",
    invitesCol: "招待数",
    typeInvite: "招待",
    typeReward: "報奨",
    typeWithdraw: "出金",
    bindTitle: "紹介者を紐付け",
    bindDesc: "紐付けはウォレットアドレス単位でサーバーに保存されるため、端末を変えても失われません。",
    bindPlaceholder: "紹介者のアドレスを入力（0x...）",
    bindButton: "署名して紐付け",
    bindFromLink: "招待リンクから",
    bindLocked: "紹介関係は一度しか設定できません。",
    bindSuccess: "紐付け完了",
    bindFailed: "紐付けに失敗しました",
    bindSelf: "自分自身は紐付けできません",
    bindCancelled: "署名がキャンセルされました",
  },
  progress: "進捗",
  timeLeft: "残り {t}",
  ended: "終了",
  fundTitle: "資金",
  fundDesc: "対応トークンごとのコントラクト残高とウォレット残高",
  token: "トークン",
  contractBalance: "コントラクト残高",
  lockedAmount: "ロック中",
  unlockTime: "ロック解除まで",
  depositToContract: "コントラクトに入金",
  withdrawToWallet: "ウォレットへ出金",
  available: "利用可能",
  max: "最大",
  withdraw: "出金",
  deposit: "入金",
  approve: "承認",
  withdrawTip: "出金後は一定期間ロックされ、期限後にウォレットへ反映されます。",
  connectWallet: "ウォレット接続",
  ...enLocale,
  // 顶级常用
  language: '言語',
  confirm: '確認',
  go: '移動',
  status: 'ステータス',
  balance: '残高',
  cash: '現金',
  createNew: '新規作成',
  home: 'ホーム',
  market: 'マーケット',
  markets: 'マーケット',
  community: "コミュニティ",
  deposit: "入金",
  bridge: "ブリッジ",
  portfolio: 'ポートフォリオ',
  license: 'ライセンス',
  withdraw: '出金',
  auditChecking: '審査中',
  insufficientFunds: '残高不足',
  buy: '購入',
  history: '履歴',
  seeMore: 'もっと見る',
  theme: 'テーマ',
  network: 'ネットワーク',
  walletBalance: 'ウォレット残高',
  collect: '受領',
  approve: '承認',
  ticket: 'ライセンス',
  category: 'カテゴリ',
  sortBy: '並び替え',
  issue: '発行',
  detail: '詳細',
  stakingType: '担保',
  stakingTypeInfo: '悪意ある結果確定を防ぐため、トークンまたは現在のNFTをステーキングしてください。',
  subscriptionAmount: '購入数量',
  subscription: 'サブスクリプション',
  subscribe: '購入',
  max: '最大',
  marketClosed: '市場終了',
  deposit: '追加',
  verifiedNFT: 'ライセンス確認',
  select: '選択',
  selected: '選択済み',
  moreNFT: 'ライセンスをさらに取得',
  forecastEvent: 'イベント',
  subscribeEndDate: '最終取引時間',
  specifyExpiryDate: '有効期限時間を指定',
  endDate: '終了時間',
  validityPeriod: '有効期限時間',
  marketEndDate: '有効期限時間',
  liquidityMin: '最小流動性',
  premiumMin: '最小プレミアム',
  paymentCurrency: '支払通貨',
  defaultOdds: 'デフォルトレバレッジ',
  setDefaultOdds: 'レバレッジ設定',
  minInvestAmout: '最低投資額設定',
  depositMargin: '流動性を追加',
  totalPayment: '支払合計',
  rewards: '報酬',
  rewardRate: '報酬率',
  release: '解除',
  fee: '手数料',
  marginFeeRate: '手数料率',
  cdsInfoOne: '予測商品を発行する際、マージンのステーク、既定レバレッジ、最低投資額の設定が必要です。',
  cdsInfoTwo: '未参加のマージンはいつでも出金可能です。',
  cdsInfoThree: '2人以上が異議を唱えた場合、コミュニティガバナンスにより発生有無を決定します。',
  deposited: '投資済み',
  issued: '発行済み',
  depositedCDS: '投資商品',
  totalProfit: '総利益',
  allOrDeposited: '総計/投資',
  rewardsOrProfit: '報酬/利益',
  estimatedInvested: '推定/投資',
  profit: '利益',
  yesterdayProfit: '前日利益',
  eventConfirming: 'イベント確認中',
  appeal: '異議',
  appealing: '異議申立中',
  appealFailed: '異議却下',
  occured: '発生',
  notOccured: '未発生',
  governanceMechanism: '異議が複数の場合、ガバナンス開始',
  appealLimit: '異議人数は1人以下',
  waitResult: '異議結果待ち',
  frozenMargin: '凍結マージン',
  marginBalance: 'マージン残高',
  cancel: 'キャンセル',
  defaultAhead: '早期発生',
  occur: '発生',
  notOccur: '未発生',
  stakingToChallenge: 'チャレンジのためステーキング',
  challenged: '異議提起済み',
  checking: '確認中',
  fail: '失敗',
  endTime: '終了までのカウントダウン',
  guaranteeing: '進行中',
  guaranteeingEvent: '予測進行中',
  confirmsEventAdvance: '早期に発生が確認されました',
  waitConfirmation: '確認待ち',
  triggerEvent: '発生が確認されました',
  notTriggerEvent: '未発生',

  appealInfoOne: '現在の予測イベントの判断が事実と異なる場合、「チャレンジ」を行い、最終結果をガバナンスで確定できます。',
  check: '確認',
  contentIllegal: '予測イベントに不適切な内容が含まれています。再編集してください。',
  subscribed: '投資商品',
  receivingCompensation: '保留中',
  received: '合計配当',
  receive: '受け取る',
  compensationAmount: '発生時の補償額',
  liquidity: '流動性',
  injectLiquidity: '流動性投入',
  uRLContent: 'URL/内容',
  resolutionSource: '参照元',
  textareaInfo: 'このイベントを簡潔に記述してください。',

  issuerResult: '発行者の結果',
  daoResult: 'DAO の結果',
  waitingGovernanceResult: 'イベントはガバナンス結果待ちです。',
  eventFinished: 'イベントは終了しました。',
  recycleTicket: 'ライセンス回収',
  eventCancelled: 'イベントはキャンセルされました。',
  challenge: 'チャレンジ',
  share: '共有',
  USDT: 'USDT',
  donations: '寄付',

  // issue.vue 顶级提示
  issueMsgPleaseSelectLicense: 'ライセンスを選択してください',
  issueMsgLicenseCannotBeStaked: 'ライセンスはステーキング不可です',
  issueMsgNetworkNotConnected: 'ネットワークが未接続です',
  issueMsgEventEmpty: 'イベントが未入力です',
  issueMsgSelectLicense: 'ライセンスを選択してください',
  issueMsgLastTradingDateEmpty: '最終取引時間が未入力です',
  issueMsgExpirationDateEmpty: '満了時間が未入力です',
  issueMsgOptionsEmpty: '選択肢は空にできません',
  issueMsgOptionsLessThanTwo: '選択肢は2つ以上必要です',
  issueMsgOptionEmpty: '選択肢が未入力です',
  issueMsgOptionRepeated: '選択肢が重複しています',
  issueMsgLastTradingDateGreaterThanToday: '最終取引時間は今日より後である必要があります',
  issueMsgLastTradingDateGreaterThanExpirationDate: '最終取引時間が満了時間より後です',
  issueMsgEventEndDateGreaterThanRentalEndDate: 'イベント終了時間 {eventEndDate} はレンタル終了時間 {rentalEndDate} より後です',
  issueMsgInsufficientBalance: '残高不足',
  issueMsgTransactionFailed: 'トランザクション失敗',
  issueMsgIssueSuccess: '発行成功',
  issueMsgTransactionCancelled: 'トランザクションはキャンセルされました',

  short: {
    ...enLocale.short,
    confirmsEventAdvance: '早期発生',
    waitConfirmation: '確認待ち',
    defaultChallenging: '発生-異議中',
    notDefaultChallenging: '未発生-異議中',
    defaultChallengeFailed: '発生-異議失敗',
    notDefaultChallengeFailed: '未発生-異議失敗',
    defaultWaitingResult: '発生-ガバナンス中',
    notDefaultWaitingResult: '未発生-ガバナンス中',
    defaultGovernanceMechanism: '発生-ガバナンス確定',
    notDefaultGovernanceMechanism: '未発生-ガバナンス確定',
  },

  wallet: {
    ...enLocale.wallet,
   openWallet: 'ウォレットを開く',
    connectWallet: 'ウォレット接続',
    connectingWallet: 'ウォレット接続中',
    connectYourWallet: 'ウォレットを接続',
    disconnect: '切断',
    wrongNetwork: 'ネットワークが間違っています',
  },

  NFT: {
    ...enLocale.NFT,
    getPrediLicense: 'Prediライセンスを取得',
    referralRewards: '紹介報酬',
    mintYourLicence: 'ライセンスをミント',
    usageRights: '利用権',
    issuePredictionProducts: '予測商品を発行',
    governance: 'ガバナンス',
    properties: 'プロパティ',
    tradable: '取引可能',
    rentable: '賃貸可能',
    usable: '使用可能',
    marketsToIssue: '発行可能なマーケット',
    times: '回数',
    availableTimes: '利用可能回数',
    ticketId: 'チケットID',
    cancelRentHint: 'このライセンスは賃貸中です。先に賃貸をキャンセルしてください。',
    seeMore: 'もっと見る',
    sell: '販売',
    rent: 'レンタル',
    share: '共有',
    common: '一般',
    scarcity: '希少',
    attributive: '属性',
    numbers: '発行番号',
    issueTip: 'ライセンスごとに10個の予測マーケットを発行',
    price: '価格',
    success: '成功',
    getNFT: 'ライセンスを取得しました',
    issueCDS: 'Prediマーケットを発行',
    buyNow: '今すぐ購入',
    mintNow: '今すぐミント',
    rule: 'ルール',
    comingSoon: '近日公開！',
    type: 'タイプ',
    from: '開始',
    to: '終了',
    me: '自分',
    rented: '賃貸済み',
    sold: '販売済み',
    tabGetLicense: 'ライセンス取得',
    tabMyLicense: 'マイライセンス',
    tabMarket: 'マーケット',
    marketDisabled: "セカンダリマーケットはまだ利用できません。",
    bought: '購入済み',
    boughtProducts: '購入商品',
    investedProducts: '投資商品',
    issuedProducts: '発行商品',
    positions: '保有ポジション',
    options: '選択肢',
    all: 'すべて',
    volume: 'ボリューム',
    newest: '最新',
    pending: '保留',
    audit: '審査',
    loading: '読み込み中',
    empowering: '先見者に力を与え、未来を予測する',
    myPositions: '私のポジション',
    challengeCredit: '異議クレジット',
    challengeStatus: '異議ステータス',
    succeed: '成功',
    wait: '待機',
    return: '戻る',
    createYourOwnMarket: '独自のマーケットを作成',
    waitChallenge: 'イベントは異議待ちです。',
    waitingGovernanceResult: 'イベントはガバナンス結果待ちです。',
    eventFinished: 'イベントは終了しました。',
    cancelled: 'キャンセル済み',
    predictionProduct: '予測商品',
    complaintCountdown: '異議申し立て期限',
    setResult: '結果の設定',
    recycleTicket: 'ライセンス回収',
    eventCancelled: 'イベントはキャンセルされました。',
    auditChecking: '審査中',
    insufficientFunds: '残高不足',
    buyTicket: 'チケットを購入',
    listYourToken: 'トークンを上場',
  },

  claim: {
    ...enLocale.claim,
    title: 'PRDsを無料で受け取る',
    subtitle: 'ワンクリックでPRDsトークンを入手',
    walletAddress: 'ウォレットアドレス',
    status: 'ステータス',
    connectWalletFirst: 'まずウォレットを接続してください',
    eligibility: {
      claimed: '既に受け取り済みです',
      eligible: '受け取り可能です',
      error: '受け取り可否の確認中にエラーが発生しました',
    },
    button: {
      claim: '受け取る',
      alreadyClaimed: '受け取り済み',
      connect: '接続',
    },
    footerNotice: '各ウォレットは一度のみ受け取れます。正しいネットワークに接続してください。',
    messages: {
      connectFirst: 'まずウォレットを接続してください',
      claimSuccess: '受け取りに成功しました！',
      claimFailed: '受け取りに失敗しました。後でもう一度お試しください',
      txCancelled: 'トランザクションはキャンセルされました',
      onlyOnce: '各ユーザーは一度のみ受け取れます',
      insufficientBalance: 'コントラクト残高不足です。後でもう一度お試しください',
    },
  },
  
  // Additional top-level keys from en.js
  inputSearchText: '検索内容を入力してください',
  predictionProduct: '予測商品',
  listYourToken: 'トークンを上場',
  description: '説明',
  positions: '保有ポジション',
  options: '選択肢',
  all: 'すべて',
  volume: 'ボリューム',
  newest: '最新',
  pending: '保留',
  audit: '審査',
  loading: '読み込み中',
  challengeCredit: '異議クレジット',
  challengeStatus: '異議ステータス',
  succeed: '成功',
  wait: '待機',
  return: '戻る',
  waitChallenge: 'イベントは異議待ちです。',
  complaintCountdown: '異議申し立て期限',
  setResult: '結果の設定',
  issueParticipateUntil: 'ユーザーは次の日までこの商品に参加できます',
  specifyLastTradingDate: '最終取引時間を指定',
  empowering: '先見者に力を与え、未来を予測する',
  amount: '数量',
  createYourOwnMarket: '独自のマーケットを作成',
  issueExpireIntro: '期限切れ時に正しいオプションを選択した人は、参加シェアに基づいて製品プールからトークンを共有します。',
  issueConfirmAdvance: 'イベントが有効期限前に発生した場合、発行者は結果を事前に確認できます。',
  issueChallengeWithin7Days: '参加者が発行者が確認したイベント結果に同意しない場合、確認後7日以内に「チャレンジ」できます。',
  issueAttention: '注意：Prediはエンターテイメントと社会的体験を促進することに取り組んでいます。あらゆる形態のギャンブル関連活動はこのプラットフォームで厳格に禁止されています。',
  eventSampleTitle: 'イベント',
  issueSampleCrypto: '[暗号] 2025年末のビットコイン価格帯は？',
  issueSampleFinance: '[金融] 2025年Q3米連邦準備制度の金利決定は？',
  issueSampleTechnology: '[技術] 最初の完全自律型AI駆動ロボットアシスタントを導入する会社は？',
  issueSampleSports: '[スポーツ] 2026 FIFAワールドカップを優勝するチームは？',
  issueSampleSociety: '[社会] 2025年に月間アクティブユーザーが最も多いソーシャルメディアプラットフォームは？',
  issueSampleOthers: '[その他] ロシア・ウクライナ戦争はいつ終わるか？',
  licenses: 'ライセンス',
  prediLicense: 'Prediライセンス',
  issuableQuantity: '発行可能数量',
  disabled: '無効',
  battleImage: '証拠画像',
  upload: 'アップロード',
  showSample: 'サンプルを見る',
  battleInformation: '紛争証拠',
  baseToken: '基本トークン',
  collateral: '担保',
  currentLicense: '現在のライセンス',
  predictionProject: '予測プロジェクト：'
}